import React, {useState, useEffect, useRef} from 'react';
import Pagination from './Pagination';
import {getNews, getNewestPressUpdate} from "../../fetcher";
import {Link} from "react-router-dom";
import './News&Blog.css'
import {withRouter} from "../../utils/with-router";

function NewsAndBlog() {

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); // Empty array means this effect runs once on mount and clean up on unmount

  const imageWidth = windowWidth * 0.35; // Or whatever calculation you need
  const imageHeight = imageWidth * 0.6;
  const divHeight = imageHeight * 1.2;

  const [news, setNews] = useState([]);
  const [press, setPress] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;

  useEffect(() => {
    const fetchNews = async () => {
      const data = await getNews();
      setNews(data.records||[]);
    };

    fetchNews();
  }, []);

  useEffect(() => {
    const fetchPress = async () => {
      const data = await getNewestPressUpdate();
      setPress(data.records||[]);
    };

    fetchPress();
  }, []);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = news?.slice(indexOfFirstItem, indexOfLastItem);
  const restPress = press?.slice(1);

  const getBackgroundImage = (json) => {
    if (json.fields.Photo) {
      return `${json.fields.Photo[0].url}`;
    }
    return `/assets/press1.svg`;
  };

  const paginate = pageNumber => setCurrentPage(pageNumber);

  return (
      <div className="newblog-main-container">
        <h1 className='newsblog_header_title'>Press Release</h1>
        <div className='newsblog-container'>
          {press.length > 0 &&
              <div className="newsblog-photo-div">
                <img className='newsblog-photo' src={getBackgroundImage(press[0])} alt="pic"/>
                <div className="newsblog-info-box">
                  <div className="newsblog-title1-container">
                    <h2 className="newsblog_photo_type">Press Update</h2>
{/*                    <div className="oval">
                      <h2 className='newsblog_tag'>{press[0].fields.Type}</h2>
                    </div>*/}
                  </div>
                  <Link to={press[0].fields.Link} className="removeStyle newsblog-title1-title" target="_blank">
                    <h2 className='newsblog_photo_title'>{press[0].fields.Title}</h2>
                  </Link>
                  <h2 className='newsblog_photo_date'>{press[0].fields.Date}</h2>
                </div>
              </div>
          }
        </div>
        <div className='box-container'>
          <div className='press1-container'>
            {restPress.map((item) => (
                <div className='n-pressUpdate_content'
                     style={{
                       height: `${divHeight}px`,
                       maxHeight: '200px',
                     }}>
                  <div className="n-pressUpdate">
                    <img className='n-pressUpdate_img'
                         style={{
                           width: `${imageWidth}px`,
                           height: `${imageHeight}px`,
                           maxWidth: '300px',
                           maxHeight: '165px',
                         }}
                         src={getBackgroundImage(item)}
                         alt="pic"/>
                  </div>
                  <div className='newsblog-pressUpdate_content_text'>
                    <Link to={item.fields.Link} className="removeStyle" style={{height: '20%'}} target="_blank">
                      <h2 className='n_content_title'>{item.fields.Title}</h2>
                    </Link>
                    <p className='n_content_detail'>{item.fields.Content.length > 20
                        ? `${item.fields.Content.substring(0, 400)}...`
                        : item.fields.Content}</p>
                    <p className='n_content_tag'>{item.fields.Type}</p>
                  </div>
                </div>
            ))}
          </div>
        </div>

        {/*all news*/}
        <div className='carousel-white-container'>
          <h1 className='allnews_title'>All News</h1>
          <li className="news_carousel_content">
            {currentItems?.map((item, index) => (
                <React.Fragment key={item.id}>
                  <div className="news">
                    <img className="news_img" src={getBackgroundImage(item)} alt="pic"/>
                    <div className='news_content'>
                      <div className='news_detail'>
                        <Link to={item.fields.Link} className="removeStyle" target="_blank">
                          <h4 className='news_content_speaker'>{item.fields.Title}</h4>
                        </Link>
                      </div>
                      <div className='news_bottom'>
                        <div className='news_bottom_div'>
                          <h4 className='news_content_date'>{item.fields.Date}</h4>
                        </div>
                        <div className='news_bottom_div'>
                          <h4 className='news_content_text'>{item.fields.Type}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={`news_divider_container ${index === currentItems.length - 1 ? 'news_divider_container_last' : ''}`}>
                    <div className="news_divider"></div>
                  </div>
                </React.Fragment>
            ))}
          </li>
        </div>

        <div className='page-footers'>
          <Pagination
              itemsPerPage={itemsPerPage}
              totalItems={news.length}
              paginate={paginate}
              currentPage={currentPage}
          />
        </div>

      </div>
  );
}

export default withRouter(NewsAndBlog);
